import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, BookImage } from "lucide-react";

// Album PDF imprimable des photos des ateliers.
export default function PhotoAlbumButton({ url, name, testId, className = "" }) {
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const { data } = await api.get(url, { responseType: "blob" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(data);
      a.download = `album-photos-${name}.pdf`;
      a.click();
      URL.revokeObjectURL(a.href);
    } catch { toast.error("Album indisponible pour le moment."); }
    finally { setBusy(false); }
  };
  return (
    <Button variant="outline" onClick={download} disabled={busy} className={`rounded-full ${className}`} data-testid={testId}>
      {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <BookImage className="w-4 h-4 mr-2" />} Album photo à imprimer (PDF)
    </Button>
  );
}
